import React from 'react'
import {Text} from '@chakra-ui/react'

import {LogoHorizontal} from '../Logo'

export const PoweredBy = () => (
  <Text
    color="mld.neutral.700"
    textStyle="body-detail"
    display="flex"
    order={{base: '1', md: '2'}}
  >
    Powered by
    <LogoHorizontal width={85} height={11} mb="sm" mt="3px" ml="xs" />
  </Text>
)

export default PoweredBy
